<template>
  <iRow
    v-if="shouldShowAction"
    width="hug"
    height="hug"
    v-bind="containerProps"
    :data-action-icon="myIcon || null"
    @click="() => !editMode && handleClick()"
  >
    <PrefixSuffixWrapper
      :prefix="myPrefix"
      :suffix="mySuffix"
      :style-bindings="textOnlyAttributes"
      :gap="myGap"
      :icon-color="myIconColor"
    >
      <iRow
        vertical-align="middle"
        wrap="nowrap"
        width="hug"
        :gap="myGap"
      >
        <iIcon
          v-if="myIcon && myIconPosition === 'beforeText'"
          :is-loading="isLoading"
          :icon="myIcon"
          :name="myIcon"
          :size="myIconSize"
          :style-overrides="{
            primaryVariantColor: myIconColor,
          }"
        />
        <iRichText
          v-if="!textIsEmpty && myIconPosition === 'beforeText'"
          ref="richTextElement"
          :model-value="initialValue"
          prevent-new-line
          :preview="previewMode"
          :show-toolbar="false"
          :show-bubble-menu="true"
          :tools-to-disable="['text-align', 'link', 'bullet-list']"
          :style-overrides="{
            borderWidth: 'none',
            borderRadius: 'none',
            paddingLeft: 'none',
            paddingRight: 'none',
            paddingTop: 'none',
            paddingBottom: 'none',
          }"
          v-bind="textOnlyAttributes"
          @blur="handleBlur"
          @keydown.enter="handleBlur"
          @update:model-value="handleTextOptionUpdate($event)"
        />
        <iColumn width="hug">
          <iText
            v-if="!countPending && myValue !== undefined && myValue !== '' && myValue !== null"
            :style-overrides="{
              standardFontColor: myCountColor,
              standardFontSize: myCountSize,
              standardHoverFontColor: myCountColor,
              standardHoverFontSize: myCountSize
            }"
          >
            {{ myValue }}
          </iText>
        </iColumn>
        <iRichText
          v-if="!textIsEmpty && myIconPosition === 'afterText'"
          ref="richTextElement"
          :model-value="initialValue"
          prevent-new-line
          :preview="previewMode"
          :show-toolbar="false"
          :show-bubble-menu="true"
          :tools-to-disable="['text-align', 'link', 'bullet-list']"
          :style-overrides="{
            borderWidth: 'none',
            borderRadius: 'none',
            paddingLeft: 'none',
            paddingRight: 'none',
            paddingTop: 'none',
            paddingBottom: 'none',
          }"
          v-bind="textOnlyAttributes"
          @blur="handleBlur"
          @keydown.enter="handleBlur"
          @update:model-value="handleTextOptionUpdate($event)"
        />
        <iIcon
          v-if="myIcon && myIconPosition === 'afterText'"
          :is-loading="isLoading"
          :icon="myIcon"
          :name="myIcon"
          :size="myIconSize"
          :style-overrides="{
            primaryVariantColor: myIconColor,
          }"
        />
      </iRow>
    </PrefixSuffixWrapper>
  </iRow>
</template>

<script>
import PrefixSuffixWrapper from "%/dynamic-component-editor/components/PrefixSuffixWrapper.vue";
import {
  ActionCountElementMixin,
} from "%/dynamic-component-editor/standard-elements/action-element/action-count-element-mixin";

export default {
  name: "ActionCountElement",
  components: { PrefixSuffixWrapper },
  mixins: [ActionCountElementMixin],
};
</script>

<style scoped lang="scss">

</style>
